import { StateToken } from '@ngxs/store';
import { Account } from '../../../models/common.models';

export const ACCOUNTS_STATE_TOKEN = new StateToken<AccountsStateModel>('accounts');

export interface AccountsStateModel {
  total: number;
  allAccounts: Account[];
}

export const FindAccount = (accnts, id) => {
  if (!id) return null;
  return accnts.find(({ adspertAccountId }) => adspertAccountId.toString() === id?.toString());
};
